import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.16536 3.14669V12.8134H11.832V3.14669H2.16536ZM0.832031 2.98002C0.832031 2.33569 1.35437 1.81335 1.9987 1.81335H11.9987C12.643 1.81335 13.1654 2.33569 13.1654 2.98002V12.98C13.1654 13.6244 12.643 14.1467 11.9987 14.1467H1.9987C1.35437 14.1467 0.832031 13.6244 0.832031 12.98V2.98002Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.9987 0.813354C10.3669 0.813354 10.6654 1.11183 10.6654 1.48002V3.48002C10.6654 3.84821 10.3669 4.14669 9.9987 4.14669C9.63051 4.14669 9.33203 3.84821 9.33203 3.48002V1.48002C9.33203 1.11183 9.63051 0.813354 9.9987 0.813354Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.9987 0.813354C4.36689 0.813354 4.66536 1.11183 4.66536 1.48002V3.48002C4.66536 3.84821 4.36689 4.14669 3.9987 4.14669C3.63051 4.14669 3.33203 3.84821 3.33203 3.48002V1.48002C3.33203 1.11183 3.63051 0.813354 3.9987 0.813354Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.832031 5.48002C0.832031 5.11183 1.13051 4.81335 1.4987 4.81335H12.4987C12.8669 4.81335 13.1654 5.11183 13.1654 5.48002C13.1654 5.84821 12.8669 6.14669 12.4987 6.14669H1.4987C1.13051 6.14669 0.832031 5.84821 0.832031 5.48002Z"
    }, null, -1)
  ])))
}
export default { render: render }